import { React, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Banner from "../Components/Banner";
import AOS from 'aos';

// Components
import Liaison_Description from "../Components/Liaison/Liaison_Description";
import Liaison_ProcessFlow from "../Components/Liaison/Liaison_ProcessFlow";
import TestimonialSlider from "../Components/testimonial_slider";
import Chatwithus from "../Components/chatwithus";
import Milestones from "../Card-Components/milestones";
import FormModal from '../Components/FormModal';
import Button from "../Components/Button";

// Banner Images
import dtpc_banner from '../images/liaison/micro-landing/dtcp_banner.png'
import landuse_banner from "../images/liaison/micro-landing/landuse_banner.png"
import layoutapproval_banner from '../images/liaison/micro-landing/layoutapproval_banner.png'
import hacanoc_banner from '../images/liaison/micro-landing/hacanoc_banner.png'



function Liaison_Sublanding() {

     useEffect(() => {
            AOS.init({ duration: 1000 });
        }, []);
    

    // Modal State & Function
    const [modalToggle, setModalToggle] = useState(false);
    function toggle() {
        setModalToggle(!modalToggle);
    }

    const params = useParams();
    const path = params.micro_id;

    const bannerdata = {
        dtcp: {
            image: dtpc_banner,
            title: "Simplify your life",
            subtitle: "Property Approval Services",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]"

        },
        landuse: {
            image: landuse_banner,
            title: "Unlocking New Possibilities in Tamil Nadu",
            subtitle: "From Fields to Facilities",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]"

        },
        layoutapproval: {
            image: layoutapproval_banner,
            title: "Designing Dreams, Building Futures",
            subtitle: "Layout crafted for Living & Investment",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[560px] lg:bottom-[100px] lg:left-[100px]"

        },
        hacanoc: {
            image: hacanoc_banner,
            title: "Your guide to Environmentally cautious Development",
            subtitle: "Approvals in compliance with environmental regulations.",
            textposition: "w-[85%] bottom-8 left-8 right-8 lg:w-[623px] lg:bottom-[100px] lg:left-[100px]"

        },

    }


    return (
        <>

            <Banner
                img={bannerdata[path].image}
                mimg={bannerdata[path].image}
                heading={bannerdata[path].title}
                subheading={bannerdata[path].subtitle}
                textposition={bannerdata[path].textposition}
                renderButton={() => (
                    <Button name={"Get Started"} design ={"filled"} action="modal-open" modalfunction={toggle} />
                )}
            />

            <Liaison_Description />

            <Liaison_ProcessFlow />

            <Milestones />

            <TestimonialSlider />

            <Chatwithus />

            <FormModal
                modal={modalToggle}
                active={toggle}
            />

        </>
    )
}

export default Liaison_Sublanding;